import { validFamilyListItemComponents } from "../../../family/components/shared/lists";
import { Drawer } from "../../Drawer/Drawer";
import { DetailsFeedListItem, DetailsFeedListItemShimmer } from "../ListItems/DetailsFeedListItem";
import { FourColumnListItem } from "../ListItems/FourColumnListItem/FourColumnListItem";
import { ListItem } from "../ListItems/ListItem/ListItem";
import { ListItemShimmer } from "../ListItems/ListItemShimmer/ListItemShimmer";
import { MobileListItem } from "../ListItems/MobileListItem/MobileListItem";
import { OneColumnListItem } from "../ListItems/OneColumnListItem/OneColumnListItem";
import { ListItemCanvas } from "../ListItems/shared/ListItemCanvas";
import { SimpleFeedListItem, SimpleFeedListItemShimmer } from "../ListItems/SimpleFeedListItem";

export const validListItemComponents: readonly React.ComponentType<any>[] = [
    ...validFamilyListItemComponents,
    DetailsFeedListItem,
    DetailsFeedListItemShimmer,
    Drawer,
    FourColumnListItem,
    OneColumnListItem,
    SimpleFeedListItem,
    SimpleFeedListItemShimmer,
    ListItemShimmer,
    ListItem,
    MobileListItem,
    ListItemCanvas
];
